import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import AntiModal from '../../common/modal/AntiModal';
import {FoundationRequestContainer} from './FoundationRequest';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Foundation extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
			open: false,
		}
	}

	componentWillMount() {
		document.title = 'Diamonds Direct Foundation';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

	renderRotatingBanner() {
  	const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 5000,
      cssEase: "linear",
      arrows: false,
    };
  	return <div className='foundationRotatingBanner'>
  		<div className="bannerLeft" onClick={::this.prevSlide}>
        <div className="leftArrow"></div>
      </div>
      <div className="bannerRight" onClick={::this.nextSlide}>
        <div className="rightArrow"></div>
      </div>
	  	<Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
	  		<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/foundation2.jpg' />
				</div>
	  		<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/beemighty5.jpg' />
				</div>
				<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/blingyrings.jpg' />
				</div>
				<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/beemighty2.jpg' />
				</div>
				<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/kylebusch.jpg' />
				</div>
				<div className={'foundationBanner rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/foundation/foundation3.jpg' />
				</div>
	  	</Slider>
  	</div>;
  }

  openModal() {
    this.setState({ open: true });
  }

  closeModal() {
    this.setState({ open: false });
  }

	render() {
		return <div className='Foundation'>
			<div className='foundationHeader'>
				<img className='headerLogo' src='https://ddw2.diamondsdirect.com/img/foundation/foundation.svg' />
				<span className='textWrapper'>The Diamonds Direct Foundation</span>
			</div>
			<div className='nkBanner' onClick={() => this.internalNav('no-kid-hungry')} style={{display: 'none'}}>
				<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_foundationb.jpg' />
				<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/nokid/DD_nokid_foundation_m.jpg' />
			</div>
			<div className='foundationBodyWrapper'>
				<div className='foundationImageBlock'>
					<div className='foundationImageWrapper'>
						<div className='foundationImageTopRow'>
							<div className='foundationImageElement'><img src='https://ddw2.diamondsdirect.com/img/foundation/foundation2.jpg' /></div>
							<div className='foundationImageElement'><img src='https://ddw2.diamondsdirect.com/img/foundation/beemighty5.jpg' /></div>
						</div>
						<div className='foundationImageBottomRow'>
							<div className={'foundationImageElement firstBottom'}><img src='https://ddw2.diamondsdirect.com/img/foundation/blingyrings.jpg' /></div>
							<div className={'foundationImageElement secondBottom'}>
								<div className='foundationInnerElementWrapper'>
									<div className='foundationInnerElementTopRow'>
										<div className={'foundationInnerElementImage innerTop'}><img src='https://ddw2.diamondsdirect.com/img/foundation/beemighty2.jpg' /></div>
									</div>
									<div className='foundationInnerElementBottomRow'>
										<div className='foundationInnerElementImage'><img src='https://ddw2.diamondsdirect.com/img/foundation/kylebusch.jpg' /></div>
										<div className='foundationInnerElementImage' style={{marginLeft: '10px'}}><img src='https://ddw2.diamondsdirect.com/img/foundation/foundation3.jpg' /></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='foundationCopyBlock'>
					<div className='foundationIconWrapper'>
						<img src='https://ddw2.diamondsdirect.com/img/foundation/foundation.svg' />
					</div>
					<div className='foundationCopyP'>
						We are dedicated to giving back to the communities we call home. The Diamonds Direct Foundation was established in 2004 to provide support to local nonprofit organizations, with special emphasis on women's and children's philanthropies.
					</div>
					<div className='foundationCopyP'>
						Our goal is to build long-term relationships with our nonprofit partners and work closely with them to develop fundraising programs that mutually benefit both organizations.
					</div>
					<div className='foundationCopyP'>
						If your organization is interested in working with the Diamonds Direct Foundation, please complete the donation request form below.
					</div>
					<div className={'foundationOpenRequestButton actionButton'} onClick={::this.openModal}>
						Donation Request Form
					</div>
				</div>
				<div className='foundationBannerWrapper'>{this.renderRotatingBanner()}</div>
			</div>
			<AntiModal 
        open={this.state.open} 
        closeMethod={::this.closeModal}
        resize={this.props.common.modalResize}
        theme={'teamBio'}>
        <FoundationRequestContainer 
          closeMethod={::this.closeModal} 
          modalOpen={this.state.open} />
      </AntiModal>
		</div>;
	}
}
export default Foundation;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const FoundationContainer = connect(
  mapStateToProps,
  allActionCreators
)(Foundation);


// WEBPACK FOOTER //
// ./src/components/views/foundation/Foundation.jsx